module.exports = __webpack_public_path__ + "img/icon_intro.863f57e2.png";